module.exports = __webpack_public_path__ + "img/app-mapping-checkin.9974e7a2.webp";